module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "TITLE"
  }, [_vm._v("A Shorter Guide to The Holy Spirit")]), _vm._v(" "), _c('p', {
    staticClass: "SUBTITLE"
  }, [_vm._v("Bible, Doctrine, Experience")]), _vm._v(" "), _c('p', {
    staticClass: "AUTHOR"
  }, [_vm._v("Anthony C. Thiselton")]), _vm._v(" "), _c('p', {
    staticClass: "COMPANY"
  }, [_vm._v("William B. Eerdmans Publishing Company"), _c('br'), _vm._v("Grand Rapids, Michigan")]), _vm._v(" "), _c('p', {
    staticClass: "COPYRIGHT"
  }, [_vm._v("© 2016 Anthony C. Thiselton"), _c('br'), _vm._v("All rights reserved"), _c('br'), _c('br'), _vm._v("Published 2016 by"), _c('br'), _vm._v("Wm. B. Eerdmans Publishing Co."), _c('br'), _vm._v("2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505"), _c('br'), _c('br'), _vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "LIBRARY"
  }, [_vm._v("Library of Congress Cataloging-­in-­Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Names: Thiselton, Anthony C., author."), _c('br'), _vm._v("Title: A shorter guide to the Holy Spirit : Bible, doctrine, experience / "), _c('br'), _vm._v("Anthony C. Thiselton."), _c('br'), _vm._v("Description: Grand Rapids, Michigan : Eerdmans Publishing Company, 2016. | "), _c('br'), _vm._v("Includes bibliographical references."), _c('br'), _vm._v("Identifiers: LCCN 2015043610 | ISBN 9780802873491 (pbk. : alk. paper)"), _c('br'), _vm._v("eISBN 9781467446266 (ePub)"), _c('br'), _vm._v("eISBN 9781467445863 (Kindle)"), _c('br'), _vm._v("Subjects: LCSH: Holy Spirit. | Holy Spirit—Biblical teaching."), _c('br'), _vm._v("Classification: LCC BT121.3 .T453 2016 | DDC 231/.3—dc23 "), _c('br'), _vm._v("LC record available at http://lccn.loc.gov/2015043610")]), _vm._v(" "), _c('p', {
    staticClass: "URL"
  }, [_c('a', {
    attrs: {
      "href": "http://www.eerdmans.com",
      "target": "_blank"
    }
  }, [_vm._v("www.eerdmans.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d992bf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thiselton_A_Shorter_Guide.vue
// module id = 57
// module chunks = 0